<div class="flex flex-col gap-4">
  @let promotion = featuredPromotion();

  <div class="flex items-center gap-2">
    <div class="flex-1 flex justify-center md:justify-between items-center">
      <span class="text-[#222528] text-[1.1875rem] md:text-[1.375rem] font-bold">{{
        'dashboard.featuredPromotions' | translate
      }}</span>
      <a
        data-testid="featured-promotions-view-all"
        routerLink="/workspace/promotions"
        class="hidden gap-[0.5rem] items-center no-underline md:flex"
      >
        <span class="font-light text-[1.125rem] leading-[1.6] text-[#007dcb]">
          {{ 'promotions.viewAll' | translate }}
        </span>
        <img
          src="assets/img/dashboard-v2/view-all-chevron.svg"
          alt=""
          aria-hidden="true"
          class="size-6 shrink-0 rotate-180 object-scale-down"
        />
      </a>
    </div>
  </div>

  @if (featuredIsLoading()) {
    <div class="flex items-center justify-center w-full py-[2rem] relative min-h-[5rem]">
      <korviu-loader></korviu-loader>
    </div>
  } @else if (promotion) {
    @if (lessThan500Ganas) {
      <div
        class="relative flex flex-col items-end gap-[1.25rem] bg-[#fcfcfc] border border-[#eeeeef] rounded-[0.5rem] p-[1.5rem] shadow-[0_5px_15px_0_rgba(138,142,148,0.1)]"
      >
        <div
          class="relative aspect-[424/240] w-full bg-[#e6f2f1] rounded-[0.5rem] flex items-center justify-center overflow-hidden"
        >
          @if (promotion.image) {
            <img [src]="promotion.image" [alt]="promotion.title" class="w-full h-full object-cover" />
          } @else {
            <img
              src="assets/img/dashboard-v2/featured-promotions-image.svg"
              alt=""
              aria-hidden="true"
              data-testid="featured-promotion-fallback-image"
              class="w-full h-full object-cover"
            />
          }
        </div>

        <div class="flex flex-wrap content-center items-center gap-[1rem] w-full">
          <div class="flex-1 flex flex-col gap-[0.75rem] min-w-[20.9375rem] max-[420px]:min-w-0">
            <div class="flex flex-col gap-[0.25rem] leading-[1.6]">
              <h3 class="font-bold text-[1.125rem] text-[#2c3035] w-full m-0">
                {{ promotion.title }}
              </h3>
              <p
                class="text-[0.9375rem] text-[#505760] leading-[1.6] overflow-hidden text-ellipsis h-[2.9375rem] line-clamp-2 m-0"
              >
                {{ promotion.description }}
              </p>
            </div>

            <div class="flex gap-[0.5rem] mt-[0.25rem]">
              <div
                class="inline-flex items-center justify-center gap-[0.5rem] px-[0.5rem] py-[0.125rem] rounded-[0.25rem] bg-[#e6f2f1] border border-[#8ac4bd]"
              >
                <span class="text-[0.9375rem] leading-[1.6] text-[#00352f] whitespace-nowrap">
                  {{ availableEntriesLabel() }}
                </span>
              </div>
            </div>
          </div>

          <div class="flex-1 flex flex-col items-center justify-center gap-[0.5rem] min-w-[12.5rem] w-full">
            <korviu-button
              class="block w-full [--button__border-radius:0.375rem] [--button__height:2.5rem]"
              color="tertiary"
              size="small"
              type="link"
              [link]="'/workspace/promotions/' + promotion.id"
            >
              <span linkText class="block w-full text-center text-[0.9375rem] leading-[1.6]">
                {{ 'dashboard.getMoreEntries' | translate }}
              </span>
            </korviu-button>

            <div class="flex items-center gap-[0.5rem]">
              <i>
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                  <path
                    d="M12.5247 1.70143C12.2349 1.41164 11.7651 1.41164 11.4753 1.70143L1.70142 11.4753C1.41164 11.7651 1.41164 12.2349 1.70142 12.5247L2.75831 13.5816C3.15132 13.3618 3.60442 13.2368 4.0847 13.2368C5.58737 13.2368 6.80553 14.4549 6.80553 15.9576C6.80553 16.438 6.68046 16.891 6.46073 17.284L7.51774 18.3411C7.80753 18.6308 8.27736 18.6308 8.56715 18.3411L18.3411 8.56715C18.6308 8.27736 18.6308 7.80754 18.3411 7.51775L17.2841 6.4608C16.891 6.68063 16.4378 6.80577 15.9574 6.80577C14.4547 6.80577 13.2366 5.58761 13.2366 4.08494C13.2366 3.60454 13.3617 3.15132 13.5816 2.75824L12.5247 1.70143ZM10.4259 0.652019C11.2953 -0.21734 12.7048 -0.21734 13.5742 0.652019L14.7331 1.81107C15.2385 2.3164 15.148 3.02578 14.8931 3.45434C14.7837 3.63841 14.7207 3.85317 14.7207 4.08494C14.7207 4.76798 15.2743 5.32168 15.9574 5.32168C16.1891 5.32168 16.4039 5.25864 16.5879 5.14919C17.0166 4.89438 17.7259 4.80382 18.2312 5.30916L19.3904 6.46833C20.2598 7.3377 20.2598 8.74722 19.3904 9.6166L9.6166 19.3904C8.74722 20.2598 7.33769 20.2598 6.46833 19.3904L5.3091 18.2312C4.80383 17.7259 4.89429 17.0167 5.14903 16.5881C5.25841 16.404 5.32144 16.1893 5.32144 15.9576C5.32144 15.2746 4.76773 14.7209 4.0847 14.7209C3.85299 14.7209 3.63827 14.7839 3.45424 14.8933C3.02567 15.1481 2.3164 15.2385 1.81113 14.7332L0.652015 13.5742C-0.217343 12.7048 -0.217333 11.2953 0.652015 10.4259L10.4259 0.652019Z"
                    fill="#505760"
                  />
                </svg>
              </i>
              <span class="text-[0.9375rem] leading-[1.6] text-[#505760] whitespace-nowrap">
                {{ ticketsLabel() }}
              </span>
            </div>
          </div>
        </div>

        <div
          class="absolute left-[2.1875rem] top-[2.1875rem] z-[1] size-[2rem] rounded-full border-[3px] border-[#fcfcfc] bg-[#eeeeef] bg-[radial-gradient(#fcfcfc_1px,transparent_1px)] bg-[length:0.25rem_0.25rem] opacity-95"
          aria-hidden="true"
        ></div>

        <div
          class="absolute right-[2.4375rem] top-[2.4375rem] inline-flex items-center gap-[0.5rem] px-[0.5rem] py-[0.125rem] rounded-[0.25rem] bg-[#ef6401] border border-[#aa4701]"
        >
          <svg class="w-[1.25rem] h-[1.25rem]" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12 7V12L14.5 14.5M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
              stroke="#fcfcfc"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span class="text-[0.9375rem] leading-[1.6] text-[#fcfcfc] whitespace-nowrap">
            {{ timeRemainingLabel() }}
          </span>
        </div>
      </div>
    } @else {
      <div class="flex flex-col gap-4 w-full">
        <div
          class="relative bg-[#fcfcfc] border border-[#eeeeef] rounded-[0.5rem] promotion-card p-[1.5rem] flex flex-col gap-[1.25rem] w-full"
        >
          <div
            class="absolute left-[2rem] top-[2rem] bg-[#ef6401] border border-[#aa4701] rounded-[0.25rem] px-[0.5rem] py-[0.125rem] flex items-center gap-[0.5rem]"
          >
            <svg class="w-[1.25rem] h-[1.25rem]" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12 7V12L14.5 14.5M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                stroke="#fcfcfc"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span class="font-normal text-[0.9375rem] leading-[1.6] text-[#fcfcfc] whitespace-nowrap">
              {{ timeRemainingLabel() }}
            </span>
          </div>

          <div
            data-testid="featured-promotion-image-slot"
            class="promotion-card__image flex-shrink-0 w-full aspect-[424/240] bg-[#e6f2f1] rounded-[0.5rem] flex flex-col items-center justify-center gap-[0.5rem] overflow-hidden"
          >
            @if (promotion.image) {
              <img [src]="promotion.image" [alt]="promotion.title" class="size-full object-cover" />
            } @else {
              <img
                src="assets/img/dashboard-v2/featured-promotions-image.svg"
                alt="UniGana"
                data-testid="featured-promotion-fallback-image"
                class="size-full object-cover"
              />
            }
          </div>

          <div data-testid="featured-promotion-content" class="flex-1 min-w-0 flex flex-col gap-[0.75rem]">
            <p
              class="font-normal text-[0.9375rem] leading-[1.6] text-[#007dcb] overflow-hidden text-ellipsis whitespace-nowrap hidden promotion-card__date"
            >
              {{ promotion.start_date | date: 'd MMM yy' }}
            </p>
            <div class="flex flex-col gap-[0.5rem] leading-[1.6] w-full">
              <h3 class="font-bold text-[1.1875rem] md:text-[1.125rem] text-[#2c3035] w-full">
                {{ promotion.title }}
              </h3>
              <p
                class="font-normal text-[0.9375rem] text-[#505760] overflow-hidden text-ellipsis h-[2.9375rem] w-full line-clamp-2"
              >
                {{ promotion.description }}
              </p>
            </div>
            <div class="flex gap-[0.5rem]">
              <div
                class="bg-[#e6f2f1] border border-[#8ac4bd] rounded-[0.25rem] px-[0.5rem] py-[0.125rem] flex items-center gap-[0.5rem]"
              >
                <span class="font-normal text-[0.9375rem] leading-[1.6] text-[#00352f] whitespace-nowrap">
                  {{ availableEntriesLabel() }}
                </span>
              </div>
            </div>
          </div>

          <div
            data-testid="featured-promotion-ticket-label"
            class="promotion-card__actions flex flex-col gap-[0.75rem]"
          >
            <korviu-button
              class="promotion-card__details"
              size="small"
              type="link"
              [link]="'/workspace/promotions/' + promotion.id"
            >
              <span linkText>{{ 'dashboard.viewDetails' | translate }}</span>
            </korviu-button>
            <div
              class="promotion-card__tickets hidden items-center gap-[0.5rem] justify-end text-[0.9375rem] leading-[1.6] text-[#505760] whitespace-nowrap"
            >
              <i>
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                  <path
                    d="M12.5247 1.70143C12.2349 1.41164 11.7651 1.41164 11.4753 1.70143L1.70142 11.4753C1.41164 11.7651 1.41164 12.2349 1.70142 12.5247L2.75831 13.5816C3.15132 13.3618 3.60442 13.2368 4.0847 13.2368C5.58737 13.2368 6.80553 14.4549 6.80553 15.9576C6.80553 16.438 6.68046 16.891 6.46073 17.284L7.51774 18.3411C7.80753 18.6308 8.27736 18.6308 8.56715 18.3411L18.3411 8.56715C18.6308 8.27736 18.6308 7.80754 18.3411 7.51775L17.2841 6.4608C16.891 6.68063 16.4378 6.80577 15.9574 6.80577C14.4547 6.80577 13.2366 5.58761 13.2366 4.08494C13.2366 3.60454 13.3617 3.15132 13.5816 2.75824L12.5247 1.70143ZM10.4259 0.652019C11.2953 -0.21734 12.7048 -0.21734 13.5742 0.652019L14.7331 1.81107C15.2385 2.3164 15.148 3.02578 14.8931 3.45434C14.7837 3.63841 14.7207 3.85317 14.7207 4.08494C14.7207 4.76798 15.2743 5.32168 15.9574 5.32168C16.1891 5.32168 16.4039 5.25864 16.5879 5.14919C17.0166 4.89438 17.7259 4.80382 18.2312 5.30916L19.3904 6.46833C20.2598 7.3377 20.2598 8.74722 19.3904 9.6166L9.6166 19.3904C8.74722 20.2598 7.33769 20.2598 6.46833 19.3904L5.3091 18.2312C4.80383 17.7259 4.89429 17.0167 5.14903 16.5881C5.25841 16.404 5.32144 16.1893 5.32144 15.9576C5.32144 15.2746 4.76773 14.7209 4.0847 14.7209C3.85299 14.7209 3.63827 14.7839 3.45424 14.8933C3.02567 15.1481 2.3164 15.2385 1.81113 14.7332L0.652015 13.5742C-0.217343 12.7048 -0.217333 11.2953 0.652015 10.4259L10.4259 0.652019Z"
                    fill="#505760"
                  />
                </svg>
              </i>
              <span>
                {{ ticketsLabel() }}
              </span>
            </div>
          </div>
        </div>
      </div>
    }

    <korviu-button class="md:hidden" size="small" type="link" link="/workspace/promotions">
      <span linkText>{{ 'promotions.viewAll' | translate }}</span>
    </korviu-button>
  } @else {
    <korviu-no-data size="medium" [message]="'dashboard.noPromotions' | translate"></korviu-no-data>
  }
</div>
